import { parseAttrs, align, clsId } from '../tools';
import { rxfn, parsebfn } from './footnote';

/* eslint-disable-next-line camelcase */
export const bdepth_btag_balign_bclass_balign2_bdot
  = [/(?:^|\n+)(\+*)([a-z][a-z0-9]*)/, align, clsId, align, /(\.+)\s/];
export const nl = /(\n{2,})/;

export function blockTag(state, p) {
  let m;
  state.closeTag('b', p.bdepth, true);
  /* eslint-disable-next-line no-cond-assign */
  if (m = rxfn.test(p.btag)) { // footnotes
    parsebfn(m[2], state, p);
  } else if (p.btag === 'include') {
    const { id } = parseAttrs(p.bclass, p.balign, null, state);
    state.cloneTag(id);
  } else {
    // shouldn't be any open inline tags when starting a new block tag
    /* eslint-disable-next-line no-empty */
    while (state.altTag('i', null, true)) { }
    state.startTag(p.btag, parseAttrs(p.bclass, p.balign, null, state),
      { alt: p.match, hardOpen: p.bdot.length > 1, type: 'b', deep: p.bdepth });
  }
}

export function blockNl(state, p) {
  state.closeTag('b');
}
